import React from 'react';
import Hdr from './shared/Hdr';
import { useState, useEffect } from 'react';
import swal from 'sweetalert';
import { apiPath } from "../src/services/apiConfig";

function Department() {
  const user = localStorage.getItem('user-info');
  const token = localStorage.getItem('token');
  const usrRole = localStorage.getItem('user-role');
  const [displayDepartment, setDisplayDepartment] = useState('none');
  const [displayUpdDepartment, setDisplayUpdDepartment] = useState('none');
  const [data, setData] = useState([]);
  const [dataStat, setDataStat] = useState();
  const [departmentName, setDepartmentName] = useState('');
  const [departmentHeading, setDepartmentHeading] = useState('');
  const [departmentCaption, setDepartmentCaption] = useState('');
  const [departmentPara1, setDepartmentPara1] = useState('');
  const [departmentPara2, setDepartmentPara2] = useState('');
  //  const [uid, setUID] = useState('');
  //  const [specialityType, setSpecialityType] = useState('1');
  const [verfied, setVerfied] = useState(true);
  const [updDepartmentName, setDepartmentUpdName] = useState('');
  const [updDepartmentHeading, setDepartmentUpdHeading] = useState('');
  const [updDepartmentCaption, setDepartmentUpdCaption] = useState('');
  const [updDepartmentPara1, setDepartmentUpdPara1] = useState('');
  const [updDepartmentPara2, setDepartmentUpdPara2] = useState('');
  const [id, setID] = useState('');
  //  const [uidErr, setUIDErr] = useState('');
  //  const [Err, SetErr] = useState([]);


  let txt = "";

  useEffect(() => {
    getDepartment()
  }, [])

  function openDepartment() {
    setDisplayDepartment('block')
  }

  function closeDepartment() {
    setDisplayDepartment('none')
  }

  function openUpdDepartment() {
    setDisplayUpdDepartment('block')
  }

  function closeUpdUser() {
    setDisplayUpdDepartment('none')
  }

  async function updateDepartment(id) {
    //alert(id+','+updSpecialityName+","+updSpecialityType)

    let result = await fetch(apiPath + "departments/" + id, {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "id": id,
        "name": updDepartmentName,
        "heading": updDepartmentHeading,
        "caption": updDepartmentCaption,
        "about_para_1": updDepartmentPara1,
        "about_para_2": updDepartmentPara2
      })
    });
    result = await result.json();

    showSwal(result.success, result.message)

    getDepartment()
  }

  async function deleteDepartment(id) {

    let result = await fetch(apiPath + "departments/" + id, {
      method: 'DELETE',
      headers: {
        "Authorization": `Bearer ${token}`
      },
    });
    result = await result.json();

    showSwal(result.success, result.message)

    getDepartment()
  }

  async function updateOperation(id) {

    let result = await fetch(apiPath + "departments/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    console.warn(result.data)

    setDepartmentUpdName(result.data.name);
    setDepartmentUpdHeading(result.data.heading)
    setDepartmentUpdCaption(result.data.caption)
    setDepartmentUpdPara1(result.data.about_para_1)
    setDepartmentUpdPara2(result.data.about_para_2)

    setID(result.data.id)

    openUpdDepartment();
  }


  function deleteOperation(id) {
    //alert(id)
    swal({
      title: "Are you sure?",
      text: "Deleting a DEPARTMENT will DELETE all SPECIALITIES and DOCTORS linked to this departmnt. Once deleted, you will not be able to recover this data!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          deleteDepartment(id);
        }
        else {
          swal("Your record is safe!");
        }
      });
  }


  //* LIST OF ALL DEPARTMENT (for initial screen)*/ 

  async function getDepartment() {
    let result = await fetch(apiPath + "departments",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })
    result = await result.json();

    setDataStat(result.success);
    setData(result.data);

    if (result.success === true) {
      setData(result.data);
    } else {
      setData([]);
      alert('error in getDepartment: ' + result.message + ' | result.success = ' + result.success + ' | apiPath: ' + apiPath + ' | token: ' + token);
    }
  }

  {/*
  function uidHandler(e) {
    setUIDErr('');
    e.preventDefault()
    let item = e.target.value
    if (!item) {
      setUIDErr("required")
    } else {
      setUID(item)
    }
  }
*/}

  function verifyDepartment() {
    setVerfied(true)
    addDepartment()
  }

  //*ADD A NEW DEPARTMENT*/ 
  async function addDepartment() {
    //    alert('Add,'+departmentName)
    if (verfied) {

      let result = await fetch(apiPath + "departments", {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "name": departmentName,
          "heading": departmentHeading,
          "caption": departmentCaption,
          "about_para_1": departmentPara1,
          "about_para_2": departmentPara2
        })
      });
      result = await result.json();
      //  console.warn(result)


      //      if (result.success) { }
      //      else {
      //        SetErr(result.data);
      //      }

      showSwal(result.success, result.message)
      getDepartment()
    }
  }


  function showSwal(stat, txt) {
    if (stat === true) {
      swal({
        title: "Success!",
        text: txt,
        icon: "success",
        button: "OK!",
      });
    } else {
      swal({
        title: "Fail!",
        text: txt,
        icon: "error",
        button: "OK!",
      });
    }
  }


  return (

    <div style={{ 'height': '90vh' }}>
      <Hdr />
      <div className="row p16">
        <div className="c12-l-8">
          <h3 className="" >ADS Hospital - User : {user} </h3>
        </div>
        <div className="c12-l-4 pr32 ">
          <p className="medium right">User : ({usrRole})</p>
        </div>
      </div>


      <div className="row p16" style={{ 'height': '90%' }}>
        <div className=" c12-l-12 cont__content p4" style={{ 'height': '100%' }}>

          <div className="row p32">
            <div className="c12-l-3">
              <h4 className="wide">Department Management</h4>
            </div>
            <div className="c12-l-7"></div>
            <div className="c12-l-2">
              <button onClick={openDepartment} type="button" name="button"
                className="btn solid round">Create Department</button>
            </div>
          </div>

          <div className="row mt16" >

            <table style={{ 'height': '100%', 'width': '100%', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
              <thead>
                <tr>
                  <th className="th-border center" width="5%">Id</th>
                  <th className="th-border left" width="15%">Name</th>
                  <th className="th-border left" width="15%">Heading</th>
                  <th className="th-border left" width="20%">Caption</th>
                  <th className="th-border left" width="25%">About Para 1</th>
                  <th className="th-border left" width="25%">About Para 2</th>
                  <th className="th-border left" width="5%">Edit</th>
                  {/*      <th className="th-border left" width="5%">Delete</th>  */}
                </tr>
              </thead>
              <tbody >
                {
                  (dataStat === true ?
                    (
                      data.map((item, index) =>
                        <tr className="tr-border" key={index}>
                          <td className="center">{item.id}</td>
                          <td className="left">{item.name}</td>
                          <td className="left">{item.heading}</td>
                          <td className="left">{item.caption}</td>
                          <td className="left">{item.about_para_1}</td>
                          <td className="left">{item.about_para_2}</td>
                          <td onClick={() => { updateOperation(item.id) }} className="center"><img src={require('./asset/images/adm_edit.png')} alt="" /></td>
                          {/*                          <td onClick={() => { deleteOperation(item.id) }} className="center"><img src={require('./asset/images/adm_del.png')} alt="" /></td>  */}
                        </tr>
                      ))
                    : <tr><td>No data</td></tr>)
                }
              </tbody>
            </table>

          </div>



          {/* SCREEN FROM ADDING NEW USER */}

          <div id="newdept" style={{ 'display': displayDepartment }} className="cont__new-deptDetails">
            <form className="" action="" method="">
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeDepartment}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32">
                <div className="c12-l-12">
                  <h2>Add Department</h2>
                  <br />
                  <div className="row">
                    <div className="c12-l-1"></div>
                    <div className="c12-l-11">

                      <p style={{ 'fontSize': '0.65rem' }}>Department Name</p>
                      <input style={{ 'fontSize': '1.0rem' }} type="text" className="box small" autoComplete="off"
                        placeholder="Department Name" onChange={(e) => setDepartmentName(e.target.value)} />

                      <p style={{ 'fontSize': '0.65rem' }}>Heading</p>
                      <input style={{ 'resize': 'none' }} className="box small" autoComplete="off" maxlength="100"
                        placeholder="Heading (maximum 100 Character)" onChange={(e) => setDepartmentHeading(e.target.value)} />

                      <p style={{ 'fontSize': '0.65rem' }}>Caption</p>
                      <textarea style={{ 'resize': 'none' }} className="box small" autoComplete="off" maxlength="350" rows="3"
                        placeholder="Caption (maximum 350 Character)" onChange={(e) => setDepartmentCaption(e.target.value)} />

                      <div className="row">
                        <div className="c12-l-1"><h3>About</h3></div>
                        <div className="c12-l-11">

                          <p style={{ 'fontSize': '0.65rem' }}>Para-1</p>
                          <textarea style={{ 'resize': 'none' }} className="box small" autoComplete="off" maxlength="500" rows="3"
                            placeholder="Para-1 (maximum 500 Character)" onChange={(e) => setDepartmentPara1(e.target.value)} />

                          <p style={{ 'fontSize': '0.65rem' }}>Para-2 (optional)</p>
                          <textarea style={{ 'resize': 'none' }} className="box small" autoComplete="off" maxlength="500" rows="3"
                            placeholder="Para-2 (maximum 500 Character)" onChange={(e) => setDepartmentPara2(e.target.value)} />
                        </div>
                      </div>
                    </div>
                  </div>

                  <button onClick={verifyDepartment} type="button"
                    className="btn solid round">Add Department</button>
                </div>
              </div>
            </form>
          </div>

          {/* SCREEN FROM UPDTAE EXISTING USER */}

          <div id="newdept" style={{ 'display': displayUpdDepartment }} className="cont__new-deptDetails">
            <form className="" action="" method="">
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeUpdUser}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32">
                <div className="c12-l-12">
                  <h2>Edit Department</h2><br />

                  <div className="row">
                    <div className="c12-l-1"></div>
                    <div className="c12-l-11">

                      <input type="hidden" value={id} />

                      <p style={{ 'fontSize': '0.65rem' }}>Department Name</p>
                      <input style={{ 'fontSize': '1.0rem' }} type="text" className="box small"
                        placeholder="Name of the Department" onChange={(e) => setDepartmentUpdName(e.target.value)}
                        value={updDepartmentName} />

                      <p style={{ 'fontSize': '0.65rem' }}>Heading</p>
                      <input type="text" className="box small" autoComplete="off" maxlength="100"
                        placeholder="Heading (maximum 100 Character)" onChange={(e) => setDepartmentUpdHeading(e.target.value)}
                        value={updDepartmentHeading} />

                      <p style={{ 'fontSize': '0.65rem' }}>Caption</p>
                      <textarea style={{ 'resize': 'none' }} className="box small" autoComplete="off" maxlength="350" rows="3"
                        placeholder="Caption (maximum 350 Character)" onChange={(e) => setDepartmentUpdCaption(e.target.value)}
                        value={updDepartmentCaption} />

                      <div className="row">
                        <div className="c12-l-1"><h3>About</h3></div>
                        <div className="c12-l-11">

                          <p style={{ 'fontSize': '0.65rem' }}>Para-1</p>
                          <textarea style={{ 'resize': 'none' }} className="box small" autoComplete="off" maxlength="500" rows="3"
                            placeholder="Para-1 (maximum 500 Character)" onChange={(e) => setDepartmentUpdPara1(e.target.value)}
                            value={updDepartmentPara1} />

                          <p style={{ 'fontSize': '0.65rem' }}>Para-2 (optional)</p>
                          <textarea style={{ 'resize': 'none' }} className="box small" autoComplete="off" maxlength="500" rows="3"
                            placeholder="Para-2 (maximum 500 Character)" onChange={(e) => setDepartmentUpdPara2(e.target.value)}
                            value={updDepartmentPara2} />
                        </div>
                      </div>
                    </div>
                  </div>

                  <button onClick={() => { updateDepartment(id) }} type="button"
                    className="btn solid round">Update Department</button>
                </div>
              </div>
            </form>
          </div>

        </div>
      </div>
    </div>
  );
}

export default Department;
